import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../context/AuthContext';
import { ExternalLink, ShoppingBag } from 'lucide-react';

export function RandomProducts({ count = 3, excludeId = null, className = '', vertical = false }) {
  const [products, setProducts] = useState([]);
  const BACKEND = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    axios.get(`${API}/deals`, { params: { limit: 30 } })
      .then(res => {
        let deals = res.data.deals.filter(d => d.id !== excludeId && (d.affiliate_url || d.url));
        for (let i = deals.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [deals[i], deals[j]] = [deals[j], deals[i]];
        }
        setProducts(deals.slice(0, count));
      })
      .catch(() => {});
  }, [excludeId, count]);

  if (products.length === 0) return null;

  // Vertical = sidebar (one below another), Horizontal = main content (grid)
  if (vertical) {
    return (
      <div className={`space-y-3 ${className}`} data-testid="random-products">
        {products.map(p => {
          const img = p.image_local_path ? `${BACKEND}${p.image_local_path}` : p.image_url;
          const buyUrl = p.affiliate_url || p.url;
          return (
            <div key={p.id} className="bg-card border border-border/40 overflow-hidden group">
              <div className="flex gap-3 p-3">
                <Link to={`/okazja/${p.slug || p.id}`} className="flex-shrink-0">
                  {img ? (
                    <div className="w-20 h-20 bg-secondary overflow-hidden">
                      <img src={img} alt="" className="w-full h-full object-cover" loading="lazy" />
                    </div>
                  ) : (
                    <div className="w-20 h-20 bg-secondary flex items-center justify-center">
                      <ShoppingBag className="w-5 h-5 text-muted-foreground/20" />
                    </div>
                  )}
                </Link>
                <div className="flex-1 min-w-0">
                  <Link to={`/okazja/${p.slug || p.id}`}>
                    <p className="text-xs font-medium text-white group-hover:text-primary transition-colors line-clamp-2 leading-tight">{p.title}</p>
                  </Link>
                  {p.deal_price && (
                    <div className="mt-1.5">
                      <span className="price-glow inline-block px-2 py-0.5"><span className="price-tag text-sm">{p.deal_price} zł</span></span>
                    </div>
                  )}
                  {buyUrl && (
                    <a href={buyUrl} target="_blank" rel="noopener noreferrer"
                      className="text-[10px] text-primary hover:text-primary/80 flex items-center gap-0.5 mt-1.5"
                      onClick={e => e.stopPropagation()}>
                      <ExternalLink className="w-2.5 h-2.5" /> Sprawdź ofertę
                    </a>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  // Horizontal grid (main content area)
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-3 gap-3 ${className}`} data-testid="random-products">
      {products.map(p => {
        const img = p.image_local_path ? `${BACKEND}${p.image_local_path}` : p.image_url;
        const buyUrl = p.affiliate_url || p.url;
        return (
          <div key={p.id} className="bg-card border border-border/40 overflow-hidden group">
            <Link to={`/okazja/${p.slug || p.id}`}>
              {img ? (
                <div className="h-32 bg-secondary overflow-hidden">
                  <img src={img} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" />
                </div>
              ) : (
                <div className="h-32 bg-secondary flex items-center justify-center">
                  <ShoppingBag className="w-6 h-6 text-muted-foreground/20" />
                </div>
              )}
            </Link>
            <div className="p-3">
              <Link to={`/okazja/${p.slug || p.id}`}>
                <p className="text-xs font-medium text-white group-hover:text-primary transition-colors line-clamp-2 leading-tight">{p.title}</p>
              </Link>
              {p.deal_price && (
                <div className="mt-2">
                  <span className="price-glow inline-block px-2 py-0.5"><span className="price-tag text-sm">{p.deal_price} zł</span></span>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
